import React, { useState } from 'react';
import { css } from '@emotion/react';
import { Collapse, Typography } from '@mui/material';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { flashStyle } from '../main/genericEmotionStyles';

const detailsStyle = css({
	display: 'flex',
	alignItems: 'center',
	alignSelf: 'flex-start',
	padding: '4px',
	border: '1px solid var(--bgColor)',
	borderRadius: '4px'
});

const noBottomBorder = css({
	borderBottom: 'none',
	borderRadius: '4px 4px 0 0'
});

function Details({ title, children, bgColor, mainColor, userStyles }) {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			<Typography
				css={[detailsStyle, isOpen && noBottomBorder, userStyles]}
				sx={{
					cursor: 'pointer',
					color: mainColor
				}}
				compnent="span"
				style={{
					'--bgColor': bgColor
				}}
				onClick={e => setIsOpen(!isOpen)}>
				<span>{title}</span>{' '}
				{isOpen ? <ArrowUpIcon css={flashStyle} /> : <ArrowDownIcon />}
			</Typography>
			<Collapse in={isOpen}>{children}</Collapse>
		</>
	);
}

export default Details;
